/**
 * Wait for next frame.
 * If `requestAnimationFrame` is not supported the promise is resolved instantly
 */
export async function nextFrame(): Promise<void> {
    return new Promise<void>((resolve) => {
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(() => resolve());
        } else {
            resolve();
        }
    });
}
